import { IconProps } from '../iconProps';

export const CircleTrendingUp = ({ size = 24, fill = '' }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill={fill}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12 24C10.68 24 9.405 23.795 8.175 23.385C6.945 22.975 5.82 22.38 4.8 21.6L6.54 19.86C7.38 20.44 8.26 20.875 9.18 21.165C10.1 21.455 11.04 21.6 12 21.6C14.66 21.6 16.925 20.665 18.795 18.795C20.665 16.925 21.6 14.66 21.6 12C21.6 9.34 20.665 7.075 18.795 5.205C16.925 3.335 14.66 2.4 12 2.4C9.34 2.4 7.075 3.335 5.205 5.205C3.335 7.075 2.4 9.34 2.4 12H0C0 10.34 0.315 8.78 0.945 7.32C1.575 5.86 2.43 4.59 3.51 3.51C4.59 2.43 5.86 1.575 7.32 0.945C8.78 0.315 10.34 0 12 0C13.66 0 15.215 0.315 16.665 0.945C18.115 1.575 19.385 2.435 20.475 3.525C21.565 4.615 22.425 5.885 23.055 7.335C23.685 8.785 24 10.34 24 12C24 13.64 23.685 15.19 23.055 16.65C22.425 18.11 21.565 19.385 20.475 20.475C19.385 21.565 18.115 22.425 16.665 23.055C15.215 23.685 13.66 24 12 24ZM2.37 19.11L7.26 14.22L10.86 17.22L16.8 11.28V14.4H19.2V7.2H12V9.6H15.12L10.74 13.98L7.14 10.98L1.11 17.01C1.33 17.47 1.525 17.845 1.695 18.135C1.865 18.425 2.09 18.75 2.37 19.11Z'
        fill='#00C951'
        fillOpacity='0.76'
      />
    </svg>
  );
};
